export const processingProvider = [
  { value: 'manual', text: 'Manual' },
  { value: 'praxis', text: 'Praxis' },
  { value: 'help2pay', text: 'help2pay' },
  { value: 'coinpayments', text: 'coinpayments' },
  { value: 'paymentasia', text: 'paymentasia' },
  { value: 'paymentasia_ab', text: 'paymentasia_ab' },
  { value: 'paymentasia_idr_va', text: 'paymentasia_idr_va' },
  { value: 'korapay', text: 'korapay' },
  { value: 'skrill', text: 'skrill' },
  { value: 'neteller', text: 'neteller' },
  { value: 'ozow', text: 'ozow' },
  { value: 'mt5', text: 'mt5' },
  { value: 'coinspaid', text: 'coinspaid' },
  { value: 'enovepay', text: 'enovepay' },
  { value: 'spayz', text: 'spayz' },
  { value: 'praxis_direct', text: 'praxis_direct' },
  { value: 'pear2pay', text: 'pear2pay' },
  { value: 'payretailers', text: 'payretailers' },
  { value: 'jenapay', text: 'jenapay' },
  { value: 'brightcard', text: 'brightcard' },
  { value: 'niobi', text: 'niobi' },
]
export const processingProviderName = {
  manual: () => 'manual',
  praxis: () => 'praxis',
  help2pay: () => 'help2pay',
  coinpayments: () => 'coinpayments',
  paymentasia: () => 'paymentasia',
  paymentasia_ab: () => 'paymentasia_ab',
  paymentasia_idr_va: () => 'paymentasia_idr_va',
  korapay: () => 'korapay',
  skrill: () => 'skrill',
  neteller: () => 'neteller',
  ozow: () => 'ozow',
  mt5: () => 'mt5',
  enovepay: () => 'enovepay',
  spayz: () => 'spayz',
  praxis_direct: () => 'praxis_direct',
  pear2pay: () => 'pear2pay',
  payretailers: () => 'payretailers',
  jenapay: () => 'jenapay',
  brightcard: () => 'brightcard',
  niobi: () => 'niobi',
}
